import { en } from './en'
import { fr } from './fr'

export const consent = {
  en,
  fr,
}
